import React, { useContext, useState, useRef } from 'react'
import gql from 'graphql-tag'
import { useMutation, useQuery } from '@apollo/client'
import { Card, Grid, Image, Button, Label, Icon, Form, Placeholder } from 'semantic-ui-react';
import moment from 'moment'
import LikeButton from '../components/LikeButton';
import { AuthContext } from '../context/auth'
import DeleteButton from '../components/DeleteButton'

export default function SinglePost(props) {
    const { user } = useContext(AuthContext);

    const commentInputRef = useRef(null);

    const postId = props.match.params.postId;

    const { loading, data } = useQuery(FETCH_POST_QUERY, {
        variables: {
            postId
        }
    });

    const [comment, setComment] = useState('');


    const [submitComment] = useMutation(SUBMIT_COMMENT_MUTATION, {
        update() {
            setComment('');
            commentInputRef.current.blur();
        },
        variables: {
            postId,
            body: comment
        },
        onError(err) {
            console.log(err)
        }
    });
    function deletePostCallback() {
        props.history.push('/')
    }

    let postMarkup;
    if (loading) {
        postMarkup =
            <Grid columns={2}>
                <Grid.Row>
                    <Grid.Column width={2}>
                        <Placeholder>
                            <Placeholder.Header image>
                                <Placeholder.Line />
                                <Placeholder.Line />
                            </Placeholder.Header>
                        </Placeholder>

                    </Grid.Column>
                    <Grid.Column width={14}>
                        <Card fluid>
                            <Card.Content>
                                <Placeholder>
                                    <Placeholder.Paragraph>
                                        <Placeholder.Line />
                                        <Placeholder.Line />
                                        <Placeholder.Line />
                                        <Placeholder.Line />
                                    </Placeholder.Paragraph>
                                </Placeholder>
                            </Card.Content>
                        </Card>
                    </Grid.Column>
                </Grid.Row>
            </Grid >
    }
    else if (!loading && !data) {
        postMarkup = <p>post was deleted</p>
    }
    else {
        const { id, body, createdAt, username, comments, likes, likeCount, commentCount, image } = data.getPost;
        postMarkup = (
            <Grid columns={1}>
                <Grid.Row>
                    <Grid.Column width={2}>
                        <Image
                            floated='right'
                            size='small'
                            src='https://picsum.photos/200'
                        />
                    </Grid.Column>
                    <Grid.Column width={14}>
                        <Card fluid>
                            <Card.Content>
                                <Card.Header>{username}</Card.Header>
                                <Card.Meta >{moment(createdAt).fromNow(true)}</Card.Meta>
                                {image &&
                                    <Card.Description>
                                        <Image src={image} className="image"></Image>
                                    </Card.Description>
                                }
                                <Card.Description>
                                    {body}
                                </Card.Description>
                            </Card.Content>
                            <hr />
                            <Card.Content extra>
                                <LikeButton user={user} post={{ id, likeCount, likes }} />
                                <Button as="div" labelPosition="right" onClick={() => console.log("comment on post")}>
                                    <Button color='blue' basic>
                                        <Icon name='comments' />
                                    </Button>
                                    <Label basic color='blue' pointing='left'>
                                        {commentCount}
                                    </Label>
                                </Button>
                                {user && user.username === username && (
                                    <DeleteButton postId={id} callback={deletePostCallback} />
                                )}
                            </Card.Content>
                        </Card>
                        {user &&
                            <Card fluid>
                                <Card.Content>
                                    <p>Post a comment</p>
                                    <Form>
                                        <div className="ui action input fluid">
                                            <input
                                                type="text"
                                                placeholder="Comment.."
                                                name="comment"
                                                value={comment}
                                                onChange={event => setComment(event.target.value)}
                                                ref={commentInputRef}
                                            />
                                            <button type="submit"
                                                className="ui button teal"
                                                disabled={comment.trim() === ""}
                                                onClick={submitComment}
                                            >Send</button>
                                        </div>
                                    </Form>
                                </Card.Content>
                            </Card>
                        }
                        {
                            comments.map(comment => (
                                <Card fluid key={comment.id}>
                                    <Card.Content>
                                        {user && user.username === comment.username && (
                                            <DeleteButton postId={id} commentId={comment.id} />
                                        )}
                                        <Card.Header>
                                            {comment.username}
                                        </Card.Header>
                                        <Card.Meta>
                                            {moment(comment.createdAt).fromNow()}
                                        </Card.Meta>
                                        <Card.Description>
                                            {comment.body}
                                        </Card.Description>
                                    </Card.Content>
                                </Card>
                            ))
                        }
                    </Grid.Column>
                </Grid.Row>
            </Grid>

        )
    }
    return postMarkup;
}

const FETCH_POST_QUERY = gql`
query($postId:ID!){
    getPost(postId:$postId){
        id body createdAt username likeCount image
        likes{
            username
        }
        commentCount
        comments{
            id username createdAt body
        }
    }
}
`
const SUBMIT_COMMENT_MUTATION = gql`
mutation($postId:ID!,$body:String!){
createComment(postId:$postId, body: $body){
    id 
    comments{
        id body createdAt username
    }
    commentCount
}
}

`